//#region src/schema/request-body-composition-index.ts
var e = Symbol();
//#endregion
export { e as REQUEST_BODY_COMPOSITION_INDEX_SYMBOL };

//# sourceMappingURL=request-body-composition-index.js.map